var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTradingContestsvgrIcon = function SvgTradingContestsvgrIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M7 20a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1H7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.681 17.5v-1.687C8.56 15.195 7 13.125 7 10.667V4h10v6.667c0 2.485-1.594 4.573-3.75 5.165V19"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "m12 7 .968 1.668 1.885.405-1.287 1.436.197 1.918-1.763-.78-1.763.78.197-1.918-1.287-1.436 1.885-.405zM7 12c-2.028-.755-3-2.709-3-5v-.5h3.083M17 6.5h2.75V7c0 2.174-.884 4.17-2.75 5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTradingContestsvgrIcon);
export default ForwardRef;